import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import ExternalLink from '~/components/Links/ExternalLink';
import { useTermsOfUseDocument } from '~/hooks/documents/useTermsOfUseDocument';

export type TermsOfUseDocumentLinkProps = {
    /** Set to true to use a shorter description text for the document. Defaults to false. */
    useTerseDescription?: boolean;
    /** Set to true to use smaller font sizes for the text elements. Defaults to false. */
    useSmallerStyles?: boolean;
};

export default function TermsOfUseDocumentLink({
    useTerseDescription = false,
    useSmallerStyles = false,
}: TermsOfUseDocumentLinkProps) {
    const { lastUpdatedPrettyPrint, url, label } = useTermsOfUseDocument();

    return (
        <Box>
            <Typography
                variant="body1"
                component="div"
                sx={useSmallerStyles ? { fontSize: '14px' } : undefined}
            >
                <FormattedMessage
                    id={
                        useTerseDescription
                            ? 'termsOfUseDialog.fileLink.terse'
                            : 'termsOfUseDialog.fileLink'
                    }
                />
                :
                <ExternalLink
                    href={url}
                    sx={{
                        marginLeft: '0.5em',
                        fontSize: useSmallerStyles ? '14px' : undefined,
                    }}
                >
                    {label}
                </ExternalLink>
            </Typography>

            <Typography
                variant="body2"
                mt={useSmallerStyles ? 0.25 : 1}
                sx={useSmallerStyles ? { fontSize: '13px' } : undefined}
            >
                <FormattedMessage
                    id="termsOfUseDialog.lastUpdated"
                    values={{ date: lastUpdatedPrettyPrint }}
                />
            </Typography>
        </Box>
    );
}
